import { lazy, type ComponentType } from "react";

const RELOAD_FLAG = "bjvb:chunk-reload";

// Wraps React.lazy so a failed dynamic import (typically a stale chunk after a
// new deploy) triggers a one-shot full reload, fetching a fresh index.html
// with the latest hashed filenames. Subsequent failures fall through so the
// router's errorElement can render.
export function lazyWithRetry<T extends ComponentType<unknown>>(
  importer: () => Promise<{ default: T }>,
) {
  return lazy(async () => {
    try {
      const mod = await importer();
      window.sessionStorage.removeItem(RELOAD_FLAG);
      return mod;
    } catch (error) {
      const alreadyReloaded = window.sessionStorage.getItem(RELOAD_FLAG);
      if (!alreadyReloaded) {
        window.sessionStorage.setItem(RELOAD_FLAG, "1");
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
